import { render, staticRenderFns } from "./Content0.vue?vue&type=template&id=cc63260c&scoped=true"
import script from "./Content0.vue?vue&type=script&lang=js"
export * from "./Content0.vue?vue&type=script&lang=js"
import style0 from "./Content0.vue?vue&type=style&index=0&id=cc63260c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc63260c",
  null
  
)

export default component.exports